<!--地址选择器-->
<template>
    <div >
        <van-popup
                position="bottom"
                @click-overlay="onClose"
                :close-on-click-overlay="false"
                v-model="show"
                style="height: 60%"
        >
            <div class="coupon-list-select">

                <div class="conpun-list flex-start" v-for="(item,index) in fList"  @click="onCouponClick(item,index)">
                    <div class="coupon-left">
                        <div class="coupon-name">{{item.title}}</div>
                        <div class="coupon-detail flex-start">
                            <div class="coupon-num flex-start">
                                <span>¥</span>{{item.price|price}}
                            </div>
                            <div class="coupon-user coupon-condition" v-if="item.can_not_use_reason">{{item.can_not_use_reason}}</div>
                        </div>
                    </div>
                    <div class="coupon-right" v-if="item.status_type=='can_use'">
                        <div class="coupon-get coupon-draw" v-if="!item.checked">立即使用</div>
                        <div class="coupon-get coupon-cancle" v-else>取消</div>
                        <div class="coupon-limit gray-light">有效期{{item.use_time_end_str}}</div>
                    </div>
                    <div class="coupon-right" v-else>
                        <div class="coupon-get coupon-error">不可用</div>
                        <div class="coupon-limit gray-light"></div>
                    </div>
                </div>

            </div>
        </van-popup>
    </div>
</template>
<style scope>
    @import '../assets/style/amendVant.css';

    .coupon-list-select{
        max-height: 500px;
        padding: 20px 0 ;
        background-color: #efefef;
        overflow-y: scroll
    }
    .gray-back {
        background: #EFEFEF;
    }

    .conpun-list {
        height: 2.1rem;
        width: 6.8rem;
        margin: 0.2rem auto;
        background: url(../assets/newImg/bg-coupon-item.png) no-repeat;
        background-size: 100% 100%;
    }
    .coupon-condition{
        font-size: 10px;
        margin-left: 10px;
        color: #fff;
        background: #fd2840;
        padding: 1px 2px;
        border-radius:4px;
    }
    .coupon-list {
        color: #999999;
    }
    .coupon-list .coupon-num{
        color: #999999;
    }
    .coupon-left {
        width: 4.8rem;
        padding: 0.3rem 0.4rem;
    }

    .coupon-name {
        font-size: 15px;
    }

    .coupon-detail {
        margin-top: 0.5rem;
    }

    .coupon-num {
        color: #FD2840;
        font-size: 24px;
    }

    .coupon-num span {
        font-size: 12px;
        margin-right: 0.1rem;
    }

    .coupon-user {
        font-size: 12px;
        margin-left: 0.2rem;
    }

    .coupon-right {
        width: 2rem;
        height: 100%;
    }

    .coupon-get {
        line-height: 0.45rem;
        text-align: center;
        width: 1.54rem;
        height: 0.45rem;
        border-radius: 0.4rem;
        font-size: 12px;
        margin-top: 0.3rem;
        margin-bottom: 0.6rem;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .coupon-limit {
        font-size: 12px;
    }

    .coupon-draw {
        color: #fff;
        background: rgba(250, 58, 77, 1);
    }
    .coupon-error {
        color: #999;
        background: #fff;
        border: 1px solid #ccc;
    }
    .coupon-cancle {
        color: rgba(250, 58, 77, 1);
        background: #fff;
        border: 1px solid rgba(250, 58, 77, 1);
    }
    .coupon-lose-img{
        width: 1.89rem;
        height: 1.41rem;
        margin-top: 0.1rem;
    }
</style>

<script>
    import {Popup,CellGroup,Cell,Switch,Area}  from  'vant'
    export default {
        name: 'CouponPicker',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            list:{
                type: Array,
                default: []
            },
            business_id:{
                type: Number,
                default: 0
            },
            index:{
                type: Number,
                default: 0
            },

        },
        components: {
            [Popup.name]:Popup,
            [CellGroup.name]:CellGroup,
            [Cell.name]:Cell,
            [Switch.name]:Switch,
            [Area.name]:Area,
        },
        data() {
            return {
                fList: [],
            }
        },

        watch: {
            show(val) {
                if(val){
                    this.fList = this.list;
                }

                // console.log(this.fList)
            },
        },
        mounted: function () {
        },
        methods: {
            onCouponClick(row,index){
                let that = this;
                if (row.status_type!='can_use'){
                    return ;
                }
                let checked = that.fList[index].checked
                if (row.single_use==1){
                    //限单独使用
                    if (!checked) {
                        //清除其他选中的
                        that.fList.map(item =>{
                            that.$set(item,'checked',false);
//                            item.checked = false;
                        })
                    }
                    that.$set(that.fList[index],'checked',checked ? false:true);
//                    that.fList[index].checked = checked ? false:true
                    // console.log('onChange',{ address: that.data.selectAddress, address_id: that.data.selectAddress.id });
                    if (!checked) {
                        that.onClose()
                    }
                }else{
                    //允许同时使用
                    if (!checked) {
                        //清除其他仅限单独使用的
                        that.fList.map(item => {
                            if (item.single_use == 1) {
                                that.$set(item,'checked',false);
//                                item.checked = false;
                            }
                        })
                    }
                    that.$set(that.fList[index],'checked',checked ? false:true);
//                    that.fList[index].checked = checked ? false:true
                    if (!checked) {
                        let checkedList = that.fList.filter(item => {
                            return item.checked == true;
                        });
                        //允许多选的优惠券
                        let noSingleUseList = that.fList.filter(item => {
                            return item.single_use == 2;
                        });
                        if (noSingleUseList.length == checkedList.length){
                            //允许多选的全部选中了
                            that.onClose()
                        }
                    }
                }
            },
            onClose(){
                let that = this;
                let checkedList = that.fList.filter(item => {
                    return item.checked == true;
                });

                console.log(checkedList)
                this.$emit("onChange", {
                    list: checkedList,
                    business_id: that.business_id,
                    index: that.index,
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// CouponPicker.vue?ab755dfc